import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, FormattedNumber } from 'react-intl';

export const AmountLineJustified = ({ labelMessage, amount, currency }) => (
    <div className="amount-line-justified">
        <div className="collapsible">
            <FormattedMessage {...labelMessage} />
        </div>
        <FormattedNumber style="currency" currency={currency} value={amount} className="collapsible" />
    </div>
);


AmountLineJustified.defaultProps = {
    currency: 'USD'
};

AmountLineJustified.propTypes = {
    labelMessage: PropTypes.object.isRequired,
    amount: PropTypes.number.isRequired,
    currency: PropTypes.string
};
